class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, this.closest('.cart-item').id, 'remove');
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('.cart-item'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    if (this.currentItemCount === 0) {
      document.getElementById('MainContent').classList.add('main-cart-empty');
    }

    if (document.querySelector('cart-items')) {
      this.initGiftNoteElements();
    }
  }

  connectedCallback() { 
    this.setEventListeners();
  }

  onChange(event) {
    const quantitySelector = event.target.closest('.cart-item').querySelector('quantity-input');
    const quantityInput = quantitySelector.querySelector('.quantity__input');

    if (!quantitySelector.classList.contains('quantity--error') || quantitySelector.classList.contains('quantity--error') && +quantityInput.max === 0 && +quantityInput.value === 0) {
      this.updateQuantity(event.target.dataset.index, event.target.value, event.target.closest('.cart-item').id);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble-mobile',
        section: document.getElementById('cart-icon-bubble-mobile').dataset.id,
        selector: '.gheader__mobile__nav-cartbtn'
      },
      {
        id: 'cart-icon-bubble',
        section: document.getElementById('cart-icon-bubble').dataset.id,
        selector: '.gheader__desktop__cart'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cart__footer',
      }
    ];
  }

  updateQuantity(line, quantity, name, updateType = '') {
    const item = document.querySelector(`#${name}`);
    const data = {};

    data[`${item.dataset.key}`] = quantity;
    const subProductsQuantity = item.querySelectorAll('.sub-products__item').length;
    if (subProductsQuantity > 0) {
      for (let i = 0; i < subProductsQuantity; i++) {
        data[`${item.querySelectorAll('.sub-products__item')[i].dataset.key}`] = quantity;
      }
    }

    //Promo campaign - remove gift product along with the main product
    if (quantity == 0 && item.nextElementSibling) {
      const $nextSibling = item.nextElementSibling.querySelector('[type="application/json"][data-item-type="main"]');
      const nextItem = JSON.parse($nextSibling.textContent);
      const itemProductId = JSON.parse(item.querySelector('[type="application/json"][data-item-type="main"]').textContent).variant_id;
      if (nextItem.properties && nextItem.properties._free_product && +nextItem.properties._related_product_id == itemProductId) {
        data[`${item.nextElementSibling.dataset.key}`] = quantity;
      }
    }

    const body = JSON.stringify({
      updates: data,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    this.enableLoading(line);

    if(updateType == 'remove') {
      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      window.dispatchEvent(new CustomEvent(
        'update_cart_quantity',
        {
          detail: {
            line_item: lineItem,
            line: line,
            name: name,
            quantity: quantity,
            item_count: line
          }
        })
      );
    }

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        document.getElementById('MainContent').classList.toggle('main-cart-empty', parsedState.item_count === 0);

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
        if (document.querySelector('cart-items')) {
          this.initGiftNoteElements();
          window.dispatchEvent(new CustomEvent('init-sfl-click-handlers'));
        }
        if(updateType != 'remove') {
        window.dispatchEvent(new CustomEvent(
          'update_cart_quantity',
          {
            detail: {
              line_item: lineItem,
              line: line,
              name: name,
              quantity: quantity,
              item_count: parsedState.item_count
            }
          })
        );
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }

  openGiftNoteModal(el) {
    this.selectedItemObj = JSON.parse(el.closest('.cart-item').querySelector('[type="application/json"][data-item-type="main"]').textContent);
    if (this.selectedItemObj.properties && this.selectedItemObj.properties['_gift_note_from']) {
      this.giftNoteForm.querySelector('.gift-note-form__from').value = this.selectedItemObj.properties['_gift_note_from'];
    }
    if (this.selectedItemObj.properties && this.selectedItemObj.properties['_gift_note_to']) {
      this.giftNoteForm.querySelector('.gift-note-form__to').value = this.selectedItemObj.properties['_gift_note_to'];
    }
    if (this.selectedItemObj.properties && this.selectedItemObj.properties['_gift_note_message']) {
      this.giftNoteForm.querySelector('.gift-note-form__textarea').value = this.selectedItemObj.properties['_gift_note_message'];
    }
    document.querySelector('.gift-note-modal').classList.add('gift-note-modal--open');
    this.tabNavs.forEach((item) => {
      item.classList.remove('gift-notes-tabs__nav--active');
    });
    this.tabNavs[0].classList.add('gift-notes-tabs__nav--active');
    this.activateTab(0);
    document.body.classList.add('overflow-hidden');

    this.giftNoteForm.querySelectorAll('.field-input').forEach(el => {
      const label = el.closest('.gift-note-form__field').querySelector('.gift-note-form__label');
      function moveLabelOut() {
        label.classList.add('gift-note-form__label--active');
        if (el.id === 'giftNoteSelectMessage') {
          el.classList.add('gift-note-form__select-note--active');
        }
      }

      function moveLabelIn() {
        label.classList.remove('gift-note-form__label--active');
        if (el.id === 'giftNoteSelectMessage') {
          el.classList.remove('gift-note-form__select-note--active');
        }
      }
      if (el.value === "") {
        moveLabelIn();
      } else {
        moveLabelOut();
      }
      el.addEventListener('focus', moveLabelOut);
      el.addEventListener('change', () => {
        if (el.value === "") {
          moveLabelIn();
        } else {
          moveLabelOut();
        }
      });
      el.addEventListener('focusout', () => {
        if (el.value === "") {
          moveLabelIn();
        }
      });
    })
  }

  closeGiftNoteModal() {
    document.querySelector('.gift-note-modal').classList.remove('gift-note-modal--open');
    this.giftNoteForm.reset();
    document.body.classList.remove('overflow-hidden');
  }

  updatePreviwTab() {
    document.querySelector('.preview-tab__message-to').innerText = this.giftNoteForm.querySelector('.gift-note-form__to').value !== '' ? `${this.giftNoteForm.querySelector('.gift-note-form__to').value},` : '';
    document.querySelector('.preview-tab__message-text').innerText = this.giftNoteForm.querySelector('.gift-note-form__textarea').value;
    document.querySelector('.preview-tab__message-from').innerText = this.giftNoteForm.querySelector('.gift-note-form__from').value !== '' ? `- ${this.giftNoteForm.querySelector('.gift-note-form__from').value}` : '';
  }

  addGiftNote() {
    let validForm = false;
    this.giftNoteForm.querySelectorAll('.field-input').forEach(el => {
      if (el.value.length > 0) {
        validForm = true;
      }
    });

    if (!validForm) {
      this.closeGiftNoteModal();
      return;
    }

    if (this.giftNoteForm.querySelector('.gift-note-form__to').value) {
      this.fullMessage += `${this.giftNoteForm.querySelector('.gift-note-form__to').value}, \n`;
    }
    if (this.giftNoteForm.querySelector('.gift-note-form__textarea').value) {
      this.fullMessage += `${this.giftNoteForm.querySelector('.gift-note-form__textarea').value} \n`;
    }
    if (this.giftNoteForm.querySelector('.gift-note-form__from').value) {
      this.fullMessage += `- ${this.giftNoteForm.querySelector('.gift-note-form__from').value}`;
    }

    let properties = {};

    if (this.selectedItemObj.properties) {
      properties = this.selectedItemObj.properties;
    }
    properties['Gift note'] = this.fullMessage;
    properties['_gift_note_from'] = this.giftNoteForm.querySelector('.gift-note-form__from').value;
    properties['_gift_note_to'] = this.giftNoteForm.querySelector('.gift-note-form__to').value;
    properties['_gift_note_message'] = this.giftNoteForm.querySelector('.gift-note-form__textarea').value;
    const body = JSON.stringify({
      id: this.selectedItemObj.key,
      quantity: this.selectedItemObj.quantity,
      properties: properties,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    this.updateGiftNote(body);
  }

  removeGiftNote(el, index) {
    this.enableLoading(index + 1);
    this.selectedItemObj = JSON.parse(el.closest('.cart-item').querySelector('[type="application/json"][data-item-type="main"]').textContent);
    const properties = this.selectedItemObj.properties;

    properties['Gift note'] = '';
    properties['_gift_note_from'] = '';
    properties['_gift_note_to'] = '';
    properties['_gift_note_message'] = '';

    const body = JSON.stringify({
      id: this.selectedItemObj.key,
      quantity: this.selectedItemObj.quantity,
      properties: properties,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    this.updateGiftNote(body, index + 1);
  }

  updateGiftNote(body, line) {
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.closeGiftNoteModal();
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        this.initGiftNoteElements();
        this.disableLoading();
      }).catch(() => {
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  activateTab(aIndex) {
    const highlightedItems = document.querySelectorAll('.gift-notes-tabs__tab');
    highlightedItems.forEach((el, index) => {
      if (aIndex === index) {
        el.style.display = 'block';
      } else {
        el.style.display = 'none';
      }
    });
  };

  initTabs() {
    this.tabNavs.forEach((el, index) =>
      el.addEventListener('click', () => {
        this.activateTab(index);
        this.updatePreviwTab();
        this.tabNavs.forEach((item) => {
          item.classList.remove('gift-notes-tabs__nav--active');
        });
        el.classList.add('gift-notes-tabs__nav--active');
      })
    );
  }

  initGiftNoteElements() {
    this.selectedItemObj = null;
    this.giftNoteForm = document.querySelector('.gift-note-form');
    this.selectNote = this.giftNoteForm.querySelector('.gift-note-form__select-note');
    this.fullMessage = '';
    this.tabNavs = document.querySelectorAll('.gift-notes-tabs__nav');
    const characters = this.giftNoteForm.querySelector('.gift-note-form__textarea-characters');
    const messageTextArea = this.giftNoteForm.querySelector('.gift-note-form__textarea');
    this.initTabs();

    this.querySelectorAll('.cart-item__gift-note').forEach(el => {
      el.addEventListener('click', () => this.openGiftNoteModal(el));
    });

    this.querySelectorAll('.gift-message__edit').forEach(el => {
      el.addEventListener('click', () => this.openGiftNoteModal(el));
    });

    this.querySelectorAll('.gift-message__remove').forEach((el, index) => {
      el.addEventListener('click', () => this.removeGiftNote(el, index));
    });

    document.querySelector('.gift-note-modal__toggle').addEventListener('click', () => this.closeGiftNoteModal());
    document.querySelector('.gift-note-modal__backdrop').addEventListener('click', () => this.closeGiftNoteModal());
    document.querySelector('.gift-note-modal__cancel').addEventListener('click', () => this.closeGiftNoteModal());
    const inputs = document.querySelectorAll('.gift-note-form__textarea, .gift-note-form__to, .gift-note-form__from');

    // Add keypress event listener
    inputs.forEach(input => {
      input.addEventListener('keypress', (event) => {
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);;
        const regex = new RegExp("^[a-zA-Z0-9 \!\'\"\,\.\(\)\?\%]+$");

        if(!regex.test(key)){
          event.preventDefault();
          return false;
        }
      });

      input.addEventListener('paste', (event) => {
        event.preventDefault();
      });
    });
    this.giftNoteForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.addGiftNote();
    });

    this.selectNote.addEventListener('change', function() {
      messageTextArea.value = this.value;
      characters.innerText = messageTextArea.getAttribute('maxlength') - messageTextArea.value.length;
      messageTextArea.dispatchEvent(new Event('change'));
    })

    this.giftNoteForm.addEventListener('change', () => this.updatePreviwTab());

    messageTextArea.addEventListener('input', () => {
      characters.innerText = messageTextArea.getAttribute('maxlength') - messageTextArea.value.length;
    });

    this.giftNoteForm.querySelectorAll('.field-input[required]').forEach(el => {
      el.addEventListener('change', () => {
        if (el.value.length < 2) {
          el.classList.add('field-input--error');
          el.closest('.gift-note-form__field').querySelector('.gift-note-form__error').classList.add('gift-note-form__error--show');
        } else {
          el.classList.remove('field-input--error');
          el.closest('.gift-note-form__field').querySelector('.gift-note-form__error').classList.remove('gift-note-form__error--show');
        }
      });
    });

    document.querySelectorAll('.cart-item__wish-list').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.selectedItemObj = JSON.parse(el.closest('.cart-item').querySelector('[type="application/json"][data-item-type="main"]').textContent);
        const index = el.closest('.cart-item').querySelector('cart-remove-button').dataset.index;
        const itemId = el.closest('.cart-item').id;
        window._swat.addToWishList({
          epi: this.selectedItemObj.variant_id,
          du: `${window.shopUrl}${this.selectedItemObj.url}`,
          empi: this.selectedItemObj.product_id,
        }, () => {
          this.updateQuantity(index, 0, itemId);
        });
      })
    });
  }

  ensureCartEmptyState() {
    const cartWrapper = document.querySelector('.main-cart-items');
    const cartFooter = document.getElementById('main-cart-footer');
    
    if (!cartWrapper || !cartFooter) {
      console.warn('Cart wrapper or footer not found');

      return;
    }
  
    const isEmpty = cartWrapper.querySelectorAll('.cart-item').length === 0;
  
    cartFooter.classList.toggle('is-empty', isEmpty);
  }

  setEventListeners() {
    window.addEventListener('load', () => {
      this.ensureCartEmptyState();
    });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
